import React, { useRef, useEffect, useState } from "react";
import { motion } from "framer-motion";

const TabBar = ({ activeTab, onTabChange, tabs, ...rest }) => {
  const [selectedTab, setSelectedTab] = useState(activeTab);
  const containerRef = useRef(null);
  const buttonRefs = useRef([]);

  useEffect(() => {
    setSelectedTab(activeTab);
  }, [activeTab]);

  useEffect(() => {
    if (containerRef.current) {
      const activeIndex = tabs.findIndex((tab) => tab.value === selectedTab);
      if (activeIndex >= 0 && buttonRefs.current[activeIndex]) {
        if (activeIndex === 0) {
          containerRef.current.scrollTo({ left: 0, behavior: "smooth" });
        } else if (activeIndex === tabs.length - 1) {
          containerRef.current.scrollTo({
            left: containerRef.current.scrollWidth,
            behavior: "smooth",
          });
        } else {
          buttonRefs.current[activeIndex].scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "center",
          });
        }
      }
    }
  }, [selectedTab, tabs]);

  return (
    <div {...rest}>
      <div
        ref={containerRef}
        className="relative flex sm:space-x-2 md:space-x-4 lg:space-x-6 xl:space-x-6 
                   bg-gray-200 sm:p-2 md:p-3 lg:p-4 rounded-xl overflow-x-auto scrollbar-hide"
      >
        {tabs.map((tab, index) => (
          <button
            key={index}
            ref={(el) => (buttonRefs.current[index] = el)}
            onClick={() => {
              setSelectedTab(tab?.value);
              onTabChange(tab?.value);
            }}
            className="relative flex justify-center items-center sm:px-4 md:px-5 lg:px-6 py-1 sm:py-2 text-gray-700 font-medium 
                       transition-all whitespace-nowrap leading-6"
          >
            {selectedTab === tab?.value && (
              <motion.div
                layoutId="underline"
                className="absolute inset-0 border border-buttonBgColor hover:border-text-darkLiver"
                transition={{ type: "spring", stiffness: 300, damping: 30 }}
              />
            )}
            <span
              className={`relative z-10 uppercase sm:text-xs md:text-base lg:text-base xl:text-base 
                          ${
                            selectedTab === tab?.value
                              ? "text-text-darkLiver"
                              : "hover:text-buttonBgColor"
                          }`}
            >
              {tab?.label}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default React.memo(TabBar);
